/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Incident_Date_PlaceholderInputs */

const en_case_field_incident_date_placeholder = /** @type {(inputs: Case_Field_Incident_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick date`)
};

const pt_br2_case_field_incident_date_placeholder = /** @type {(inputs: Case_Field_Incident_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a data`)
};

/**
* | output |
* | --- |
* | "Pick date" |
*
* @param {Case_Field_Incident_Date_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_incident_date_placeholder = /** @type {((inputs?: Case_Field_Incident_Date_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Incident_Date_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_incident_date_placeholder(inputs)
	return pt_br2_case_field_incident_date_placeholder(inputs)
});